import React from "react";

import Alternate from "./Alternate";
import Social from "./Social";

const DEFAULT_SITE_TITLES = {
  en: "Spikex | AI-Driven CopyTrading & Crypto Trading Platform",
  "zh-CN": "Spikex | AI 驱动跟单 & 加密货币交易平台",
  "zh-HK": "Spikex | AI 驅動跟單 & 加密貨幣交易平台",
  pt: "Spikex | Copy Trading com IA & Plataforma de Negociação de Criptomoedas",
  ar: "Spikex | نسخ التداول بالذكاء الاصطناعي & منصة تداول العملات المشفرة",
  vi: "Spikex | Copy Trading bằng AI & Nền tảng Giao dịch Crypto",
  es: "Spikex | Trading de criptomonedas con IA y copy trading",
  ja: "Spikex | AI暗号資産取引＆コピートレードプラットフォーム",
  ko: "Spikex | AI 암호화폐 거래 & 카피 트레이딩 플랫폼",
  ru: "Spikex | AI-торговля криптовалютой и копитрейдинг",
  tr: "Spikex | AI Kripto Para Ticareti ve Kopya Ticaret Platformu",
  hi: "Spikex | AI क्रिप्टो ट्रेडिंग और कॉपी ट्रेडिंग प्लेटफ़ॉर्म",
  in: "Spikex | Platform Trading Crypto AI & Copy Trading",
  th: "Spikex | แพลตฟอร์มเทรดคริปโตด้วย AI และ Copy Trading",
};

export default function SEO({ tdk = {}, tenant, category="home", isFuture=false, lang="en", resolvedUrl, Head=React.Fragment, domain="www"}) {

  /** CMS 未返回 describe 时，按当前语言填充 meta description / og:description / twitter:description */
  const defaultDescription = {
    "zh-CN":
      "Spikex 是 AI 驱动跟单 & 加密货币交易平台，面向加密货币、外汇与大宗商品，支持期货等多元产品，安全、全球化服务。",
    "en":
      "Spikex is an AI-Driven CopyTrading & Crypto Trading Platform for crypto, forex, and commodities—offering Futures, smart tools, and secure global execution.",
    "es": "Spikex - El Primer Exchange Social del Mundo",
    "hi": "Spikex-दुनिया का पहला सामाजिक संचार एक्सचेंज",
    "zh-HK":
      "Spikex 是 AI 驅動跟單 & 加密貨幣交易平台，面向加密貨幣、外匯與大宗商品，支援期貨等多元產品，安全、全球化服務。",
    "in": "Spikex - Platform Bursa Bersosialisasi Pertama di Dunia",
    "pt":
      "A Spikex é uma plataforma de Copy Trading com IA e negociação de criptomoedas para crypto, forex e commodities — com Futuros, ferramentas inteligentes e execução global segura.",
    "ar":
      "سبيكس هي منصة نسخ التداول بالذكاء الاصطناعي وتداول العملات المشفرة للعملات المشفرة والفوركس والسلع — مع العقود الآجلة والأدوات الذكية وتنفيذ آمن على مستوى العالم.",
    "ja": "Spikex-世界初のソーシャルネットワーク型取引プラットフォーム",
    "ko": "Spikex - 세계 최초의 소셜 거래소",
    "ru": "Spikex - первая в мире криптовалютная биржа на базе сообщества",
    "th": "The World's First Social Infused Exchange",
    "tr": "Spikex - Dünyanın İlk Topluluk Odaklı Kripto Para Borsası",
    "vi":
      "Spikex là nền tảng Copy Trading bằng AI & giao dịch tiền mã hóa cho crypto, forex và hàng hóa — với Futures, công cụ thông minh và thực thi an toàn trên toàn cầu."
  };

  const seoLang = !lang || lang === "default" ? "en" : lang;

  const DEFAULT_KEYWORDS = {
    en: ["Spikex", "AI-Driven CopyTrading", "Crypto Trading Platform", "Copy Trading"],
    vi: ["Spikex", "Copy Trading bằng AI", "Nền tảng Giao dịch Crypto", "Copy Trading"],
    ar: ["Spikex", "نسخ التداول بالذكاء الاصطناعي", "منصة تداول العملات المشفرة", "Copy Trading"],
    pt: ["Spikex", "Copy Trading com IA", "Plataforma de Negociação de Criptomoedas", "Copy Trading"],
    "zh-CN": ["Spikex", "AI 驱动跟单", "加密货币交易平台", "跟单交易"],
    "zh-HK": ["Spikex", "AI 驅動跟單", "加密貨幣交易平台", "跟單交易"],
  };

  const rawTitle = typeof tdk.title === "string" ? tdk.title.trim() : "";
  const resolvedTitle =
    !rawTitle || rawTitle === "Spikex"
      ? (DEFAULT_SITE_TITLES[seoLang] || DEFAULT_SITE_TITLES.en)
      : rawTitle;

  const rawDescribe =
    typeof tdk.describe === "string" ? tdk.describe.trim() : "";
  const resolvedDescription =
    rawDescribe || defaultDescription[seoLang] || defaultDescription["en"];

  const fallbackKeywords = DEFAULT_KEYWORDS[seoLang] || DEFAULT_KEYWORDS.en;
  const resolvedKeywords = Array.isArray(tdk.keyword)
    ? tdk.keyword
    : typeof tdk.keyword === "string" && tdk.keyword.trim()
      ? tdk.keyword.split(",").map((k) => k.trim()).filter(Boolean)
      : fallbackKeywords;

  var tdkInfo = {
    title : resolvedTitle,
    description : resolvedDescription,
    keywords : resolvedKeywords,
  };

  return (
    <Head>
      <title>{tdkInfo.title}</title>
      <meta name="description" content={tdkInfo.description} />
      <meta name="keywords" content={tdkInfo.keywords.join(",")} />
      <meta
        name="viewport"
        content="minimal-ui,width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
      />
      {resolvedUrl != null && resolvedUrl !== "" ? (
        <Alternate lang={seoLang} resolvedUrl={resolvedUrl} domain={domain} />
      ) : null}
      <Social
        tdk={tdkInfo}
        tenant={tenant}
        lang={seoLang}
        category={category}
        isFuture={isFuture}
        resolvedUrl={resolvedUrl}
        domain={domain}
      />
    </Head>
  );
}
